<template>
  <div class="login">
    <div class="wrap ">
      <div class="txt-center col-white pt-50">
        <span class="font-20">ERROR PAGE</span>
        <br>
        <span class="font-30 bold">
          <p v-if="code==400">Bad Request</p>
          <p v-if="code==401">Unauthorized</p>
          <p v-if="code==402">Payment Required</p>
          <p v-if="code==403">Forbidden</p>
          <p v-if="code==404 || !code">Not Found</p>
          <p v-if="code==405">Method Not Allowed</p>
          <p v-if="code==406">Not Acceptable</p>
          <p v-if="code==407">Proxy Authentication Required</p>
          <p v-if="code==408">Request Timeout</p>
          <p v-if="code==409">Conflict</p>
          <p v-if="code==410">Length Required</p>
          <p v-if="code==411">Gone</p>
          <p v-if="code==412">Precondition Failed</p>
          <p v-if="code==413">Request Entity Too Large</p>
          <p v-if="code==414">Request-URI Too Long</p>
          <p v-if="code==415">Unsupported Media Type</p>
          <p v-if="code==416">Requested Range Not Satisfiable</p>
          <p v-if="code==417">Expectation Failed</p></span>
        <br><br>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'error',
  data: () => ({
    //code:404,
  }),
  mounted() {
    //    this.doc_del_rendar();
    //this.code = this.$route.query.code;
  },
}
</script>

<style lang="scss" scoped>
$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9;
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.wrap {
  width: 90%;
  max-width: 700px;
  margin: 0 auto;
}

//
.login {
  background: url("../assets/img/login-bg.png") no-repeat center -250px;

  .wrap {
    max-width: 500px;
  }

  h1 {
    padding-top: 40px;

    span {

      font-size: 18px;
      color: #ffffffb3;
      display: block;
    }
  }

  .box {
    border-radius: 20px;
    padding: 20px;
    background: #ffffff;
    border-radius: 20px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);

    p {
      font-size: 14px;
    }

    label {
      width: 100%;
      font-size: 14px;
      color: #585858;
    }
  }
}

@media only screen and (max-width: 414px) {
  .box {
    border-radius: 0px;
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
}

input[type="text"],
input[type="password"] {
  border-radius: 0;
  border-top: none;
  border-right: none;
  border-left: none;
  border-bottom: 1px solid #E9E9E9;
  font-size: 16px;
  height: 45px;
  padding: 0 10px;
}

input[type="checkbox"] {
  display: none;
}

input[type="checkbox"]+span {
  display: inline-block;
  width: 15px;
  height: 15px;
  background: none;
  border: 1px solid $point-color;
  cursor: pointer;
  vertical-align: middle;
}

input[type="checkbox"]:checked+span {
  width: 15px;
  height: 15px;
  background: $point-color url("../assets/img/checkbox.png") no-repeat center;
  background-size: 12px;
}

.btn-login {
  display: inline-block;
  background: $point-color;
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
  border-radius: 10px;
  padding: 10px 0;
  cursor: pointer;
}
</style>